import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import { fetchPositionsQueryOptions } from "@/modules/chart/admin/services";
import GroupList from "@/modules/messenger/admin/components/group/GroupList";

export const Route = createFileRoute(
  "/admin/_panel/_messenger/messenger/groups/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "messenger.messenger-group.view");

    return {
      crumb: [
        {
          label: context.t("Manage Groups", { ns: "messenger.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchPositionsQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("messenger.admin");

  return (
    <Container
      title={t("Manage Groups")}
      description={t("Manage groups and edit them")}
    >
      <GroupList />
    </Container>
  );
}
